import { render, staticRenderFns } from "./allCategories.vue?vue&type=template&id=32a2e51a&scoped=true&"
import script from "./allCategories.vue?vue&type=script&lang=js&"
export * from "./allCategories.vue?vue&type=script&lang=js&"
import style0 from "./allCategories.vue?vue&type=style&index=0&id=32a2e51a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32a2e51a",
  null
  
)

export default component.exports